import { useEffect, useMemo, useRef, useState } from 'react';

import { IAlphaMiniCartModel, IOrderItem } from 'Types/Litium';

const DiscountInput = ({
    item,
    translations,
    onChangeHandler,
}: {
    item: IOrderItem;
    translations: IAlphaMiniCartModel['translations'];
    onChangeHandler: (
        item: IOrderItem,
        discountAmount: number,
        discountType: string
    ) => void;
}) => {
    const DISCOUNT_TYPE_FIXED = 'fixed';
    const DISCOUNT_TYPE_PERCENT = 'percent';
    const [prevDiscountAmount, setPrevDiscountAmount] = useState(0);

    const [discountAmount, setDiscountAmount] = useState(
        item.discount?.amount || 0
    );

    const onSetDiscountAmount = amount => {
        const parsedAmount = parseFloat(amount);

        if (isNaN(parsedAmount)) {
            setDiscountAmount(0);
        } else if (
            discountType === DISCOUNT_TYPE_PERCENT &&
            parsedAmount > 100
        ) {
            setDiscountAmount(100);
        } else {
            setDiscountAmount(parsedAmount);
        }
    };

    const handleLostFocus = () => {
        if (prevDiscountAmount !== discountAmount) {
            onChangeHandler(item, discountAmount, discountType);
        }

        setPrevDiscountAmount(discountAmount);
    };

    const [discountType, setDiscountType] = useState(
        item.discount?.discountType || DISCOUNT_TYPE_FIXED
    );

    const onSetDiscountType = type => {
        setDiscountType(type);

        if (type === DISCOUNT_TYPE_PERCENT && discountAmount > 100) {
            setDiscountAmount(100);
        }

        if (discountAmount > 0) {
            onChangeHandler(item, discountAmount, type);
        }
    };

    return (
        <div className="mb-1 leading-4">
            <span className="mb-1 text-xs">{translations.orderDiscount}</span>
            <div>
                <input
                    value={discountAmount}
                    onChange={event => {
                        onSetDiscountAmount(event.target.value);
                    }}
                    onBlur={() => {
                        handleLostFocus();
                    }}
                    type="number"
                    className="h-7 w-full border py-1 pl-3.5 pr-1 text-sm"
                />
            </div>
            <div className="flex justify-between py-1 text-sm">
                <span>
                    <input
                        type="radio"
                        name="discount-type"
                        value={DISCOUNT_TYPE_FIXED}
                        checked={discountType === DISCOUNT_TYPE_FIXED}
                        onChange={() => onSetDiscountType(DISCOUNT_TYPE_FIXED)}
                    />{' '}
                    {translations.customerServiceCartCurrency}
                </span>
                <span>
                    <input
                        type="radio"
                        name="discount-type"
                        value={DISCOUNT_TYPE_PERCENT}
                        checked={discountType === DISCOUNT_TYPE_PERCENT}
                        onChange={() =>
                            onSetDiscountType(DISCOUNT_TYPE_PERCENT)
                        }
                    />{' '}
                    %
                </span>
            </div>
        </div>
    );
};

export default DiscountInput;
